.priceSwingRefinementContainer {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
}

.radioGroup {
  display: flex;
  flex-direction: column;
  margin-top: var(--cxy-spacing-2);
}

.resetButton {
  align-self: center;
}

@media screen and (min-width: 801px) {
  .radioGroup {
    flex-direction: row;
  }
  .radioGroup label {
    gap: var(--cxy-spacing-1);
  }
}
